import HTTP from '@/api/HTTP';
import transformer from '@/services/compta/lot/lotServerTableDataTransformer';

const URL_BASE = 'gescom/IfLot/';

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function getAll(search) {
  const inputServer = transformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function create(input) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', input);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function annulerTransmission(id) {
  const response = await HTTP.post(URL_BASE + 'AnnulerTransmissionAsync', { id: id });
  return response;
}
